import { useEffect, useRef } from 'react'

import { FulfilledRequest, RequestStatus } from '@signavio/kraken'

type CallbackT<Value> = (value: Value, request: FulfilledRequest<Value>) => void

function useCallbackWhenRequestFulfills<Value>(
  request: RequestStatus<Value>,
  callback: CallbackT<Value>
): void {
  const callbackRef = useRef(callback)
  const wasFulfilledBefore = useRef(request.fulfilled)
  const initialRun = useRef(true)
  const lastQuery = useRef(request.query)

  useEffect(() => {
    callbackRef.current = callback
  }, [callback])

  useEffect(() => {
    if (request.fulfilled) {
      if (!wasFulfilledBefore.current) {
        callbackRef.current(request.value, request)
      } else if (lastQuery.current !== request.query) {
        callbackRef.current(request.value, request)
      } else if (initialRun.current) {
        callbackRef.current(request.value, request)
      }

      wasFulfilledBefore.current = request.fulfilled
      lastQuery.current = request.query
    }

    initialRun.current = false
  }, [request])

  useEffect(() => {
    if (!request.fulfilled && wasFulfilledBefore.current) {
      wasFulfilledBefore.current = false
    }
  }, [request.fulfilled])
}

export default useCallbackWhenRequestFulfills
